import { render, staticRenderFns } from "./TimberFileOutput.vue?vue&type=template&id=4fc6c03c&scoped=true&"
import script from "./TimberFileOutput.vue?vue&type=script&lang=js&"
export * from "./TimberFileOutput.vue?vue&type=script&lang=js&"
import style0 from "./TimberFileOutput.vue?vue&type=style&index=0&id=4fc6c03c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc6c03c",
  null
  
)

export default component.exports